export default __webpack_public_path__ + "static/media/cable-car-cabin.99b6807a.png";